module.exports = __webpack_public_path__ + "static/antibody_grey-70742340ae401fceb709116f5c8fbbeb.png";